import { apiAuthClient } from 'shared/api/lib';

import type {
  PostAuthLoginRequestType,
  PostAuthLoginResponseType,
} from '../types';

export const postAuthLogin = async ({
  bodyParams,
}: PostAuthLoginRequestType) => {
  const url = '/api/v2/auth/login';

  const { data } = await apiAuthClient.post<PostAuthLoginResponseType>(
    url,
    bodyParams,
  );

  return data.data;
};
